import { AssetTypes, FinancialInstitutionTypes } from "@nestoca/multi-tenant";

import { financialTypes, giftTypes, basicAssetTypes } from "./asset.const";

import type {
  BaseAsset,
  GiftAsset,
  PropertyAsset,
  VehicleAsset,
  FinancialAsset,
  FinancialOtherAsset,
  FinancialInstitutionAsset,
  OtherAsset,
  CreateAsset,
  BasicAsset,
  AssetResponse,
} from "./asset";

export const isCreateAsset = (data: Partial<BaseAsset>): data is CreateAsset =>
  !("id" in data);


export const isBasicAsset = (data: Partial<BaseAsset>): data is BasicAsset =>
  basicAssetTypes.includes(data.type ?? "");

export const isGiftAsset = (data: Partial<BaseAsset>): data is GiftAsset =>
  giftTypes.includes(data.type ?? "");

export const isPropertyAsset = (
  data: Partial<BaseAsset>
): data is PropertyAsset => data.type === AssetTypes.PROPERTY;

export const isVehicleAsset = (
  data: Partial<BaseAsset>
): data is VehicleAsset => data.type === AssetTypes.VEHICLE;

export const isFinancialAsset = (
  data: Partial<BaseAsset>
): data is FinancialAsset => financialTypes.includes(data.type ?? "");

export const isFinancialOtherAsset = (
  data: Partial<BaseAsset>
): data is FinancialOtherAsset =>
  isFinancialAsset(data) && data.institution === FinancialInstitutionTypes.OTHER;

export const isFinancialInstitutionAsset = (
  data: Partial<BaseAsset>
): data is FinancialInstitutionAsset =>
  isFinancialAsset(data) && data.institution !== FinancialInstitutionTypes.OTHER;

export const isOtherAsset = (data: Partial<BaseAsset>): data is OtherAsset =>
  data.type === AssetTypes.OTHER;

export const isAssetResponse = (
  data: Partial<BaseAsset>
): data is AssetResponse => !isCreateAsset(data) && !("applicantId" in data);
